<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.signataire.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('general.signataire.detail.contactPrincipal')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <p class="has-text-weight-bold"> {{ signataire.contactPrincipal }}</p>
          </b-field>
        </div>
        <div class="column is-8"></div>
        <div class="column is-4">
          <b-field :label="$t('general.signataire.detail.signataireRelance')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
          <p class="has-text-weight-bold"> {{ signataire.signataireRelance }}</p>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('general.signataire.detail.fonctionSignataireRelance')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <p class="has-text-weight-bold"> {{ signataire.fonctionSignataireRelance }}</p>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field
            v-if="forSociete"
            :label="$t('general.signataire.detail.emailSignataireRelance')"
            custom-class="has-text-weight-normal is-italic is-marginless">
            <p class="has-text-weight-bold"> {{ emailSignataireRelance }}</p>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('general.signataire.detail.signataireBaux')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <p class="has-text-weight-bold"> {{ signataire.signataireBaux }}</p>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('general.signataire.detail.fonctionSignataireBaux')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <p class="has-text-weight-bold"> {{ signataire.fonctionSignataireBaux }}</p>
          </b-field>
        </div>
        <div class="column is-4"></div>
        <div class="column is-4">
          <b-field :label="$t('general.signataire.detail.signataireRecouvrement')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <p class="has-text-weight-bold"> {{ signataire.signataireRecouvrement }}</p>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('general.signataire.detail.telephoneRecouvrement')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <p class="has-text-weight-bold"> {{ signataire.telephoneRecouvrement }}</p>
          </b-field>
        </div>
        <div class="column is-4"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    signataire: {
      type: Object,
      required: true,
    },
    forSociete: {
      type: Boolean,
      required: false,
      default: false,
    },
    emailSignataireRelance: {
      type: String,
      required: false,
      default: '',
    },
  },
};

</script>
